<template>
	<vs-tabs>
		<vs-tab label="Ship Details">
			<cat-cruise-details-ship :result="result" />
		</vs-tab>
		<vs-tab label="Itinerary">
			<cat-cruise-details-itinerary :result="result" />
		</vs-tab>
		<vs-tab label="Alternative Dates">
			<cat-cruise-details-alternative-dates :result="result" class="test"/>
		</vs-tab>
		<vs-tab label="Alternative Products">
			<cat-cruise-details-alternative-products :result="result" />
		</vs-tab>
		<vs-tab label="Pricing Insights">
			<cat-cruise-details-pricing-insights :result="result" />
		</vs-tab>
		<vs-tab label="Crowd Reviews">
			<cat-cruise-details-crowd-reviews :result="result" />
		</vs-tab>
		<vs-tab label="Matching">
			<cat-cruise-details-matching :result="result" />
		</vs-tab>
	</vs-tabs>
</template>

<script>
import CatCruiseDetailsShip from '@/components/cat/CruiseDetailsShip.vue'
import CatCruiseDetailsItinerary from '@/components/cat/CruiseDetailsItinerary.vue'
import CatCruiseDetailsAlternativeDates from '@/components/cat/CruiseDetailsAlternativeDates.vue'
import CatCruiseDetailsAlternativeProducts from '@/components/cat/CruiseDetailsAlternativeProducts.vue'
import CatCruiseDetailsPricingInsights from '@/components/cat/CruiseDetailsPricingInsights.vue'
import CatCruiseDetailsCrowdReviews from '@/components/cat/CruiseDetailsCrowdReviews.vue'
import CatCruiseDetailsMatching from '@/components/cat/CruiseDetailsMatching.vue'

export default {
  components: {
    CatCruiseDetailsShip,
    CatCruiseDetailsItinerary,
    CatCruiseDetailsAlternativeDates,
	CatCruiseDetailsAlternativeProducts,
	CatCruiseDetailsPricingInsights,
    CatCruiseDetailsCrowdReviews,
    CatCruiseDetailsMatching
  },
  props: {
    result: {
      type: Object,
      required: true
    }
  }
}
</script>
